import { render, staticRenderFns } from "./EmployeeManagement.vue?vue&type=template&id=5be855fc"
import script from "./EmployeeManagement.vue?vue&type=script&lang=js"
export * from "./EmployeeManagement.vue?vue&type=script&lang=js"
import style0 from "./EmployeeManagement.vue?vue&type=style&index=0&id=5be855fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports